<template>
    <div class="tree-edit-panel" @click="clickHandler" @mousedown="mouseDownHandler">
        <div v-for="opr in operators" :key="opr.val" :attr-v="opr.val" :class="opr.cls">
            <Tips :text="opr.tips" class="tips" :top="isFirst ? 25 : -35" />
        </div>
    </div>
</template>

<script>
import Tips from "@/views/zhiji/bComponents/Tips";

/**
 * editFlags=["add", "edit", "delete", "move"], 都是可选
 */
export default {
    name: "EditPanel",
    props: ["editFlags", "isFirst"],
    components: {
        Tips
    },
    computed: {
        tipsLabels() {
            return {
                add: this.$t("zhiji.common.add"),
                edit: this.$t("zhiji.common.edit"),
                delete: this.$t("zhiji.common.delete"),
                move: this.$t("zhiji.common.move")
            };
        },
        operators() {
            return this.editFlags.map(flag => {
                return {
                    val: flag,
                    cls: flag,
                    tips: this.tipsLabels[flag]
                };
            });
        }
    },
    methods: {
        clickHandler(event) {
            let target = event.target;
            let val = target.getAttribute("attr-v");

            if (val) {
                this.$emit("oprClick", val);
            }
        },
        mouseDownHandler(event) {
            let target = event.target;
            let val = target.getAttribute("attr-v");

            if (val === "move") {
                this.zhiji.dragStart(event, "tree-node-wrapper", "v", newIdx => {
                    this.$emit("transferEnd", newIdx);
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.tree-edit-panel {
    & > div {
        position: relative;
        display: inline-block;
        width: 18px;
        height: 18px;
        margin: 0 5px 0 5px;
        top: 10px;
        background: url("@{zhijiStaticImagePath}class-spr.png");
        cursor: pointer;

        &:hover {
            .tips {
                display: inline-block;
            }
        }
    }

    .tips {
        display: none;
    }

    .edit {
        background-position: -76px 0;

        &:hover {
            background-position: -76px -22px;
        }
    }

    .add {
        background-position: -56px 0;

        &:hover {
            background-position: -56px -22px;
        }
    }

    .delete {
        width: 16px;
        background-position: -96px 0;

        &:hover {
            background-position: -96px -22px;
        }
    }

    .move {
        width: 13px;
        background-position: -113px 0;

        &:hover {
            background-position: -113px -22px;
        }
    }
}
</style>
